var React = require('react');

function RightPointingArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M525.459 6.40592C525.713 6.15253 525.714 5.74098 525.46 5.48668L521.331 1.34265C521.078 1.08835 520.666 1.08761 520.412 1.34099C520.158 1.59437 520.157 2.00593 520.41 2.26023L524.081 5.94381L520.397 9.61413C520.143 9.86751 520.142 10.2791 520.395 10.5334C520.649 10.7877 521.06 10.7884 521.315 10.535L525.459 6.40592ZM0.998827 5.65L524.999 6.59547L525.001 5.29547L1.00117 4.35L0.998827 5.65Z","fill":"#1B1A1A"}));
}

RightPointingArrow.defaultProps = {"width":"526","height":"11","viewBox":"0 0 526 11","fill":"none"};

module.exports = RightPointingArrow;

RightPointingArrow.default = RightPointingArrow;
